<template lang="pug">
  .sub-final-scope
    div(style="margin-left: 20px")
      el-row
        el-col(
          style="color: #3370d2"
          :span="4"
        ) {{ $t('Sub SOW') }} {{ index + 1 }}

      el-row
        el-col(:span="4") {{ $t('名称') }}
        el-col(:span="10") {{ data.sub_final_scope_name }}

      el-row
        el-col(:span="4") {{ $t('报价') }}
        el-col(:span="17")
          QuotationOverview(
            :data="data.price_overview"
            :vendors="data.vendor"
          )
      el-row
        el-col.required(:span="4") {{ $t('选择供应商') }}
        el-col(:span="4")
          el-radio-group(v-model="data.selectedVendor")
            el-radio(
              v-for="item, index in data.vendor"
              :key="index"
              :label="item.vendor_id"
            ) {{ $t('供应商') + (index + 1) }}: {{ item.vendor_name_ch }}/{{ item.vendor_name }}

      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="4" style="position: relative")
          el-input(
            v-model="data.remark"
            type="textarea"
            :rows="8"
            :key="index"
            style="width: 380px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
</template>

<script>
import QuotationOverview from '@/components/QuotationOverview'

export default {
  components: {
    QuotationOverview
  },
  model: {
    prop: 'data'
  },
  props: {
    data: {
      type: Object,
      default () {
        return {
          name: '',
          selectedVendor: null,
          remark: '',
          vendor: []
        }
      }
    },
    index: {
      type: Number,
      default () {
        return 1
      }
    }
  }
}
</script>

<style lang="stylus">
.sub-final-scope
  .el-radio-group
    display flex
    flex-direction column
    .el-radio
      margin-top 5px
    .el-radio+.el-radio
      margin-left 0
</style>
